module.exports = __webpack_public_path__ + "img/manual-filter-01-filter-panel.d44b04c3.png";